module.exports = __webpack_public_path__ + "static/media/blog-hai-ask@3x.1e8722d4.jpg";